module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "form-inline ml-auto row no-gutters search-form"
  }, [_c('div', {
    staticClass: "document col-1 pl-0"
  }, [_c('icon', {
    attrs: {
      "name": "file-text-o",
      "scale": "1.25"
    }
  })], 1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchRequest),
      expression: "searchRequest"
    }],
    staticClass: "form-control col",
    attrs: {
      "type": "text",
      "placeholder": "Search Title, Abstract, Author, Keyword"
    },
    domProps: {
      "value": (_vm.searchRequest)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchRequest = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "button-wrapper col-1 p-0"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'searchResults',
        params: {
          request: _vm.searchRequest
        }
      }
    }
  }, [_c('b-button', {
    staticClass: "button-secondary button-square my-2 my-sm-0",
    attrs: {
      "disabled": !_vm.searchRequest,
      "type": "submit"
    }
  }, [_c('div', {
    staticClass: "icon icon-search"
  })])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b278e788"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main-layout/header-nav/SearchFieldComponent.vue
// module id = 1470
// module chunks = 1